import React from 'react'
import Helmet from 'react-helmet'
import clsx from 'clsx'
import {Meta} from '../reducers/commonTypes'
import Bold from '../assets/SF-UI-Text-Bold.otf'
import Medium from '../assets/SF-UI-Text-Medium.otf'
import Regular from '../assets/SF-UI-Text-Regular.otf'
import Semibold from '../assets/SF-UI-Text-Semibold.otf'
import Light from '../assets/SF-UI-Text-Light.otf'
import Block from '../assets/SF-UI-Text-Block.otf'

// Meta
// 1.标准 seo name content
// 2.Open Graph - Facebook / 微信 / LinkedIn
// 3.Twitter
// 4.type & 多语言
// 5.IOS & Anriod
// 6.al App 深度链接 & Web App 支持

interface MyHelmetProps {
  title?: string
  meta?: Meta
  baseHref?: any
  isSaada?: boolean
  SaadaIcon?: string
  h_language?: string
  client?: any
  otherInfo?: any
  isGame?: boolean
  url?: string
}

const MyHelmet = (props: MyHelmetProps) => {
  const {
    title,
    meta,
    baseHref,
    isSaada,
    SaadaIcon,
    h_language,
    client,
    otherInfo,
    isGame,
    url,
  } = props
  return (
    <Helmet>
      <title>{meta?.title || title}</title>
      {/* 相关分享的meta 配置 start --- */}
      {/* 只能使用挨个&方式进行处理 */}
      {/* 1.标准 seo name content */}
      {meta?.title && (
        <meta key="meta-seo-title" name="title" content={meta?.title} />
      )}
      {meta?.description && (
        <meta
          key="meta-seo-description"
          name="description"
          content={meta?.description}
        />
      )}
      {/* 2.Open Graph - Facebook / 微信 / LinkedIn  */}
      {meta?.title && (
        <meta key="og-title" property="og:title" content={meta?.title} />
      )}
      {url && <meta key="og-url" property="og:url" content={url} />}
      {meta?.image && (
        <meta key="og-image" property="og:image" content={meta?.image} />
      )}
      {meta?.imageWidth && (
        <meta
          key="og-image-width"
          property="og:image:width"
          content={meta?.imageWidth}
        />
      )}
      {meta?.imageHeight && (
        <meta
          key="og-image-height"
          property="og:image:height"
          content={meta?.imageHeight}
        />
      )}
      {meta?.description && (
        <meta
          key="og-description"
          property="og:description"
          content={meta?.description}
        />
      )}
      {/* 3.Twitter */}
      <meta key="twitter:card" name="twitter:card" content="summary" />
      {meta?.title && (
        <meta key="twitter-title" name="twitter:title" content={meta?.title} />
      )}
      {url && <meta key="twitter-url" name="twitter:url" content={url} />}
      {meta?.image && (
        <meta key="twitter-image" name="twitter:image" content={meta?.image} />
      )}
      {meta?.description && (
        <meta
          key="twitter-description"
          name="twitter:description"
          content={meta?.description}
        />
      )}
      {/* 4.type & 多语言 */}
      <meta
        data-n-head="ssr"
        data-hid="og:type"
        property="og:type"
        content="website"
      />
      <meta
        data-n-head="ssr"
        data-hid="i18n-og"
        property="og:locale"
        content="en"
      />
      {/* 5.IOS & Anriod */}
      {meta?.openApp && (
        <meta key="al-ios-url" property="al:ios:url" content={meta?.openApp} />
      )}
      <meta property="al:ios:app_store_id" content="1526086695" />
      {meta?.app && <meta property="al:ios:app_name" content={meta?.app} />}
      {meta?.openApp && (
        <meta
          key="al-android-url"
          property="al:android:url"
          content={meta?.openApp}
        />
      )}
      {meta?.package && (
        <meta property="al:android:package" content={meta?.package} />
      )}
      {meta?.app && (
        <meta
          property="al:android:app_name"
          content={meta?.app || 'Hiya-Group Voice Chat'}
        />
      )}
      {/* 6.al App 深度链接 & Web App 支持 */}
      {url && <meta key="al-web-url" property="al:web:url" content={url} />}
      {/* 相关分享的meta 配置  end --- */}
      <base href={`//${baseHref}`} />
      {isSaada && (
        <link rel="shortcut icon" type="image/x-icon" href={SaadaIcon} />
      )}
      {[Bold, Medium, Regular, Semibold, Light, Block].map((v) => (
        <link
          key={v}
          rel="preload"
          href={v}
          crossOrigin=""
          as="font"
          type="font/otf"
        />
      ))}
      <body
        data-lang={h_language}
        className={clsx({
          bg_clear: !client || otherInfo.bg_clear || isGame,
        })}
      />
    </Helmet>
  )
}

export default MyHelmet
